<template>
  <a-modal
    title="提示"
    :destroyOnClose="true"
    v-model="visible"
    :confirmLoading="loading"
    @ok="handleOk"
  >
    <a-form :form="form">
      <a-form-item label="审核不通过原因">
        <a-textarea
          placeholder="请填写审核不通过原因"
          :rows="4"
          v-decorator="[
            'dismiss_reason',
            { rules: [{ required: true, message: '请填写原因' }] }
          ]"
        ></a-textarea>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import Api from "@/api";
export default {
  name: "CancelModal",
  data() {
    return {
      visible: false,
      loading: false,
      id: -1,
      form: this.$form.createForm(this)
    };
  },
  methods: {
    show(id) {
      this.id = id;
      this.visible = true;
    },
    close() {
      this.selectedTags = [];
      this.stage = 0;
      this.loading = false;
      this.visible = false;
    },
    handleOk() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.loading = true;
          try {
            await Api.post.examineRefuse({
              ...values,
              job_id: this.id
            });
            this.close();
            this.$emit("ok");
          } catch (e) {}
          this.loading = false;
        }
      });
    }
  }
};
</script>
<style lang="scss"></style>
